// Hand-maintained route-tree (no @tanstack/router-cli installed in U1).
// Add a route → add an import below + extend `routeTree` + Register.
// This file mirrors what `tsr generate` would emit; future M-step swaps in
// the codegen with zero call-site changes.

import { Route as rootRoute } from "@/routes/__root";
import { Route as IndexRoute } from "@/routes/index";
import { Route as LoginRoute } from "@/routes/login";
import { Route as AcceptInviteTokenRoute } from "@/routes/accept-invite.$token";
import { Route as ResetPasswordTokenRoute } from "@/routes/reset-password.$token";
import { Route as MeetingsIndexRoute } from "@/routes/meetings.index";
import { Route as MeetingsMeetingIdRoute } from "@/routes/meetings.$meetingId";
import { Route as ClientsIndexRoute } from "@/routes/clients.index";
import { Route as ClientsClientIdRoute } from "@/routes/clients.$clientId";
import { Route as EmployeesIndexRoute } from "@/routes/employees.index";
import { Route as EmployeesEmployeeIdRoute } from "@/routes/employees.$employeeId";
import { Route as AdminMeetingTypesRoute } from "@/routes/admin.meeting-types.index";
import { Route as AdminPromptsRoute } from "@/routes/admin.prompts.$meetingTypeId";
import { Route as AdminApiKeysRoute } from "@/routes/admin.api-keys.index";
import { Route as AdminSettingsRoute } from "@/routes/admin.settings.index";
import { Route as AdminUsersRoute } from "@/routes/admin.users.index";
import { Route as AdminCustomFieldsRoute } from "@/routes/admin.custom-fields.index";
import { Route as AdminFoldersRoute } from "@/routes/admin.folders.index";
import { Route as AdminErrorsRoute } from "@/routes/admin.errors.index";
import { Route as AdminAnalysisTemplatesRoute } from "@/routes/admin.analysis-templates.index";
import { Route as AnalysesIndexRoute } from "@/routes/analyses.index";
import { Route as AnalysesAnalysisIdRoute } from "@/routes/analyses.$analysisId";

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  LoginRoute,
  AcceptInviteTokenRoute,
  ResetPasswordTokenRoute,
  MeetingsIndexRoute,
  MeetingsMeetingIdRoute,
  ClientsIndexRoute,
  ClientsClientIdRoute,
  EmployeesIndexRoute,
  EmployeesEmployeeIdRoute,
  AdminMeetingTypesRoute,
  AdminPromptsRoute,
  AdminApiKeysRoute,
  AdminSettingsRoute,
  AdminUsersRoute,
  AdminCustomFieldsRoute,
  AdminFoldersRoute,
  AdminErrorsRoute,
  AdminAnalysisTemplatesRoute,
  AnalysesIndexRoute,
  AnalysesAnalysisIdRoute,
]);
